import { Component, EventEmitter, Input, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import * as Leaflet from 'leaflet'; // Import Leaflet as L
import { Farm, FarmLocations } from '../../../models/types';
import { MapService } from '../../services/map.service';
import { ProfilePageService } from '../../services/profile-page.service';
declare let L: any;
@Component({
  selector: 'app-map',
  standalone: true,
  imports: [],
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {
  map: Leaflet.Map | undefined = undefined;
  markers: Leaflet.Marker[] = [];
  selectedLocation: FarmLocations | null = null;
  @Input() farmLocations: FarmLocations[] = [];
  @Input() inputFarmID: number | undefined;
  @Output() locationSelected = new EventEmitter<FarmLocations>();
  @Input() interactive: boolean = true;
  @Input() onSportsPage: boolean = false;
  currentFarm: Farm | null = null;
  gpxLayer: any = null;
  

  constructor(private profilePageService: ProfilePageService) { }

  ngOnInit(): void {
    console.log('Farm Locations in map-component:', this.farmLocations);
    this.initMap();
    this.placeMarkers();
    if (this.onSportsPage){
      this.loadGpxRoute();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['farmLocations'] && !changes['farmLocations'].firstChange) {
      console.log('Farm input changed:', this.farmLocations);
      this.placeMarkers();
    }
  }

  initMap(): void {
  // Fix for missing marker icons using a CDN
  delete (Leaflet.Icon.Default.prototype as any)._getIconUrl;

  Leaflet.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
  });

  this.map = Leaflet.map('map', {
    center: [45.926259, 14.142462],
    zoom: 13,
    tap: this.interactive,
    preferCanvas: true,
  });

  const tiles = Leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 18,
    minZoom: 3,
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  });

  tiles.addTo(this.map);

    this.map.on('click', (event: Leaflet.LeafletMouseEvent) => {
      const { lat, lng } = event.latlng;
      this.selectedLocation = {
        latitude: lat,
        longitude: lng,
        farmID: 9, 
      };
      this.placeMarkersOnRegister(); // Update markers on map
      this.emitSelectedLocation(); // Emit selected location to parent component
    });
  }

  placeMarkers(): void {
    // 🧹 Clear previously added markers
    this.clearMarkers();
  
    let markerArray: Leaflet.Marker[] = [];
    console.log('Farm Locations in map-component:', this.farmLocations);
  
    this.farmLocations.forEach((farmLocation) => {
      if (this.inputFarmID === undefined || farmLocation.farmID === this.inputFarmID) {
        let marker = Leaflet.marker([farmLocation.latitude, farmLocation.longitude]);
  
        this.profilePageService.getFarmInfoForUser(farmLocation.farmID).subscribe((response) => {
          this.currentFarm = response.body;
          marker.bindTooltip(`<strong>${this.currentFarm?.name}</strong><br>${this.currentFarm?.address}`, {
            permanent: false,
            direction: 'top',
          });
        });
  
        markerArray.push(marker);
      }
    });
  
    this.markers = markerArray;
    Leaflet.featureGroup(markerArray).addTo(this.map!);
  }
  
  
  placeMarkersOnRegister(): void {
    if (this.interactive) {
      if (!this.selectedLocation) {
        return;
      }
      
      // Clear existing markers
      this.clearMarkers();
      
      const { latitude, longitude } = this.selectedLocation;
      const marker = Leaflet.marker([latitude, longitude]);
      this.markers = [marker];
      Leaflet.featureGroup(this.markers).addTo(this.map!);
    } else {
      return;
    }
  }

  // Function to clear existing markers
  clearMarkers(): void {
    this.markers.forEach(marker => this.map!.removeLayer(marker));
    this.markers = [];
  }

  emitSelectedLocation(): void {
    if (this.selectedLocation) {
      this.locationSelected.emit(this.selectedLocation);
    }
  }

  loadGpxRoute(): void {
    if (!this.map) return;
  
    // Remove existing GPX layer if needed
    if (this.gpxLayer) {
      this.map.removeLayer(this.gpxLayer);
      this.gpxLayer = null;
    }
  
    // Delay to ensure L.GPX is defined
    setTimeout(() => {
      try {
        const url = 'assets/Hot100proga.gpx'; 
        const options = {
          async: true,
          polyline_options: { color: 'red' },
        };
  
        this.gpxLayer = new L.GPX(url, options)
          .on('loaded', (e: any) => {
            this.map!.fitBounds(e.target.getBounds());
          })
          .addTo(this.map!);
      } catch (err) {
        console.error('Error loading GPX:', err);
      }
    }, 0);
  }
  
  
}